import { useQueryHistoryCheckDetails } from '@hooks/historyCheck/useQueryHistoryCheckDetails';
import { useQueryHistoryCheckParametersFilter } from '@hooks/historyCheck/useQueryHistoryCheckParametersFilter';
import { useQueryHistoryCheckSiteIdsFilter } from '@hooks/historyCheck/useQueryHistoryCheckSiteIdsFilter';

import { ICMMavenirVendor } from '@interfaces/cmModule/cmModule';
import { THistoryCheckDetailsDTO } from '@interfaces/cmModule/dto/historyCheckDTO';

import useQueryHistoryCheckConfigIdsFilter from './useQueryHistoryCheckConfigIdsFilter';
import useQueryHistoryCheckGNBIdsFilter from './useQueryHistoryCheckGNBIdsFilter';
import useQueryHistoryCheckMoFilter from './useQueryHistoryCheckMoFilter';
import useQueryHistoryCheckMoNames from './useQueryHistoryCheckMoNames';

type TUseHistoryDetailsParams = THistoryCheckDetailsDTO & ICMMavenirVendor & {
	onlyChanged?: boolean;
	isAwtgRanVendor?: boolean;
};

export const useHistoryDetails = (params: TUseHistoryDetailsParams) => {
	const {
		comparisonId,
		isMavenirVendor,
		isAwtgRanVendor,
	} = params;

	const { historyDetails, isLoadingDetails } = useQueryHistoryCheckDetails({ ...params, isAwtgRanVendor });

	const { parameterFilterOptions } = useQueryHistoryCheckParametersFilter(isAwtgRanVendor ? '' : comparisonId);
	const { siteIdFilterOptions } = useQueryHistoryCheckSiteIdsFilter(isAwtgRanVendor ? '' : comparisonId);
	const { gnbIdsOptions } = useQueryHistoryCheckGNBIdsFilter(isAwtgRanVendor ? '' : comparisonId);
	const { configIdsOptions } = useQueryHistoryCheckConfigIdsFilter(isAwtgRanVendor ? '' : comparisonId);
	const { moNames, isLoadingMoNames } = useQueryHistoryCheckMoNames({
		comparisonId: isAwtgRanVendor ? '' : comparisonId,
		isMavenirVendor,
	});
	const { detailsMoFilters } = useQueryHistoryCheckMoFilter({
		comparisonId: isAwtgRanVendor ? '' : comparisonId,
		moNames: isAwtgRanVendor ? [] : moNames,
	});

	return {
		distName: historyDetails?.distName || null,
		parameterFilterOptions,
		siteIdFilterOptions,
		gnbIdsOptions,
		moNames,
		configIdsOptions,
		detailsMoFilters,
		comparisonId: historyDetails?.comparisonId || null,
		historyDetails: historyDetails?.rows?.items || [],
		historyDetailsTotal: historyDetails?.rows?.count || 0,
		isLoadingDetails: isLoadingDetails || isLoadingMoNames,
	};
};
